export default class Image {
  static async delete(axios, imagesIds) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteImages(imagesIds: ${imagesIds}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteImages.ok;
  }

  static async create(axios, images) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        createImages(
          images: ${images} 
        ) {
          ok
          imagesIds
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    if (response.data.data.createImages.ok) {
      return response.data.data.createImages.imagesIds
    } else {
      return [];
    }

  }

  static async filter(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query {
        imageList(url_Iexact: "${payload.url}"){
          results {
            id
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return  response.data.data.imageList.results.length ? response.data.data.imageList.results[0].id : -1;
  }

  static async imageIdList(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query {
        imageIdList(url: ${payload.url}){
          results
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    /*console.log(
      `query {
        imageIdList(url: ${payload.url}){
          results
        }
      }`      
    )
    console.log(response.data.data.imageIdList.results)*/
    return  response.data.data.imageIdList.results;
  }
}